<template>
  <a :href="cartPage" class="main-header__quote-btn">
    Quotes
    <span @mouseover="circleAni.restart()">
      {{ totalProducts + totalFinishes }}
    </span>
  </a>
</template>

<script setup>
import { cartState } from '../../Cart/Store.js'
import { finishState } from '@/components/Cart/finishStore.js'
import { useStore } from 'vuex'
import { computed, watch, ref, onMounted } from 'vue'
import gsap from 'gsap'
const store = useStore()
const cartPage = computed(() => {
  return store.state.acf_options.global_quote_page.replace(store._state.data.site.url, '')
})

const { totalProducts, cart } = cartState()
const { finishes, totalFinishes } = finishState()
const circleAni = ref()

onMounted(() => {
  circleAni.value = gsap.to('.circle', {
    scale: 1.2,
    yoyo: true,
    repeat: 1,
    duration: 0.5
  })
})

watch([cart, finishes], () => {
  if (circleAni.value) circleAni.value.restart()
})

</script>

<style lang="scss" scoped>

</style>
